"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.set = set;
exports.del = del;

var _immutable = require("immutable");

var ImmutableAPI = _interopRequireWildcard(require("crm_data/api/ImmutableAPI"));

var _SettingsAPICommon = require("./SettingsAPICommon");

var defaultQuery = (0, _immutable.fromJS)({
  length: 500,
  internal: false
});

function reduceSetting(reduction, setting) {
  return reduction.set(setting.get('key'), setting.get('value'));
}

function parseSettings(results) {
  return results.get('settings').reduce(reduceSetting, (0, _immutable.Map)());
}

function setQuery(portalId, key, value) {
  return {
    hubId: portalId,
    internal: false,
    key: key,
    value: value
  };
}

function uri(portalId) {
  return "hubs/v1/hubs/" + portalId + "/settings";
}

function fetch(portalId) {
  (0, _SettingsAPICommon.enforcePortalId)(portalId);
  return ImmutableAPI.get(uri(portalId), defaultQuery.toJS()).then(parseSettings);
}

function set(portalId, key, value) {
  (0, _SettingsAPICommon.enforcePortalId)(portalId);
  (0, _SettingsAPICommon.enforceKey)(key);
  return ImmutableAPI.post(uri(portalId), setQuery(portalId, key, value));
}

function del(portalId, key) {
  (0, _SettingsAPICommon.enforcePortalId)(portalId);
  (0, _SettingsAPICommon.enforceKey)(key);
  return ImmutableAPI.delete(uri(portalId) + "/" + key, defaultQuery.toJS());
}